import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval, of } from 'rxjs';
import { filter, first, switchMap } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../../../../photographer-panel/src/environments/environment';

type SWUpdateMethod = 'navigation' | 'immediate';

@Injectable({
  providedIn: 'root',
})
export class SWUpdatesService {
  updateMethod: SWUpdateMethod = 'navigation';

  constructor(appRef: ApplicationRef, updates: SwUpdate, router: Router) {
    // Allow the app to stabilize first, before starting polling for updates with `interval()`.
    if (!environment.production || !updates.isEnabled) {
      return;
    }
    const appIsStable$ = appRef.isStable.pipe(
      first((isStable) => isStable === true),
    );
    const everySixHours$ = interval(3600 * 1000);
    const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

    everySixHoursOnceAppIsStable$.subscribe(() => updates.checkForUpdate());

    updates.versionUpdates
      .pipe(
        filter((event) => event.type === 'VERSION_READY'),
        switchMap(() =>
          this.updateMethod === 'navigation'
            ? router.events.pipe(filter((ev) => ev instanceof NavigationEnd))
            : of(null),
        ),
      )
      .subscribe((event) => {
        console.log('TRY TO RELOAD');
        updates.activateUpdate().then(() => document.location.reload());
      });
    updates.unrecoverable.subscribe((event) => {
      document.location.reload();
    });
  }

  setUpdateMethod(method: SWUpdateMethod) {
    this.updateMethod = method;
  }
}
